import { render, staticRenderFns } from "./SolutionSheetItemSpanRestraintsSubItemFibreUpper.vue?vue&type=template&id=2cb12126&scoped=true&"
import script from "./SolutionSheetItemSpanRestraintsSubItemFibreUpper.vue?vue&type=script&lang=js&"
export * from "./SolutionSheetItemSpanRestraintsSubItemFibreUpper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cb12126",
  null
  
)

export default component.exports